import styled from 'styled-components';
import { ModalWindow } from '../../../../../ui-toolkit';

export const StyledConfirmEscrowModalWindow = styled(ModalWindow)`
  & {
    justify-items: start;
    text-align: left;
    * {
      text-align: left;
    }
  }
`;
